import { render, staticRenderFns } from "./CourseAgreementTab.vue?vue&type=template&id=065a9784&scoped=true"
import script from "./CourseAgreementTab.vue?vue&type=script&lang=js"
export * from "./CourseAgreementTab.vue?vue&type=script&lang=js"
import style0 from "./CourseAgreementTab.vue?vue&type=style&index=0&id=065a9784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065a9784",
  null
  
)

export default component.exports